import axios from "axios";

const isCookieEnabled = navigator.cookieEnabled;

const DEV_CONFIG = {
  bffBaseEndpoint: "https://dev-bff.nymus.eu",
  keycloakUrl: "https://dev-idp.nymus.eu/auth",
  keycloakRealm: "test",
  keycloakClient: "test",
};

const COOKIE_ERROR_MESSAGE = `Er is een fout opgetreden. Gelieve uw browser te refreshen.
Moest u nog steeds problemen ondervinden, raden wij u aan de instelling te wijzigen naar 'allow third party cookies'.

An error has occurred. Please refresh your browser.
Should you still encounter problems, we recommend changing the setting to 'allow third party cookies'.

Une erreur s'est produite. Veuillez rafraîchir votre navigateur.
Si vous rencontrez toujours des problèmes, nous vous recommandons de modifier le paramètre pour "autoriser les cookies tiers".`;

function setLoginPageConfig(sgData) {
  const additionalPortalConfig =
    sgData.data.channelsConfig.docImage.configPortal.additionalPortalConfig;
  window.newLoginPage = additionalPortalConfig?.nymusLoginPage || false;
}

function fetchSupplierGroupAndLoadApp() {
  return axios
    .get(window._env_.VUE_APP_BFF_URL + "/api/supplier-group/current")
    .then((res) => {
      setLoginPageConfig(res.data);
      require("./app");
    });
}

function setupDevelopmentEnvironment() {
  axios.defaults.headers.common["x-sg-bridge-host"] =
    process.env.VUE_APP_BRIDGE_HOST;
  axios.defaults.headers.common["x-sg-bridge-token"] =
    process.env.VUE_APP_BRIDGE_TOKEN;

  window._env_.VUE_APP_BFF_URL = DEV_CONFIG.bffBaseEndpoint;
  window.environment = {
    ...DEV_CONFIG,
    bffUrl: DEV_CONFIG.bffBaseEndpoint,
  };

  fetchSupplierGroupAndLoadApp();
}

function setupProductionEnvironment() {
  axios.get(window._env_.VUE_APP_BFF_URL + "/environment").then((res) => {
    res.data.data.bffUrl = window._env_.VUE_APP_BFF_URL;
    window.environment = res.data.data;
    fetchSupplierGroupAndLoadApp();
  });
}

if (isCookieEnabled) {
  if (process.env.NODE_ENV === "development") {
    setupDevelopmentEnvironment();
  } else {
    setupProductionEnvironment();
  }
} else {
  alert(COOKIE_ERROR_MESSAGE);
}
